import React from 'react';
import './Catalog.css';

const whatsappNumber = '918368305178';

const makhanaPricing = [
  { name: 'Gud Caramel Makhana', items: '65g pack' },
  { name: 'Pudina Makhana', items: '65g pack' },
  { name: 'Bhuna Jeera Makhana', items: '65g pack' },
  { name: 'Heeng Makhana', items: '65g pack' },
];

const hairCareCombos = [
  { name: 'Mini Shampoo', items: '1 × PPS Shampoo – 100ml', price: 299 },
  { name: 'Mini Hair Oil', items: '1 × PPS Sampoorna Hair Oil – 50ml', price: 299 },
  { name: 'Classic Shampoo', items: '1 × PPS Shampoo – 200ml', price: 499 },
  { name: 'Classic Hair Oil', items: '1 × PPS Sampoorna Hair Oil – 100ml', price: 499 },
  { name: 'Shampoo Duo', items: '2 × PPS Shampoo – 200ml each', price: 899 },
  { name: 'Hair Oil Duo', items: '2 × PPS Sampoorna Hair Oil – 100ml each', price: 899 },
  {
    name: 'Complete Hair Care Duo',
    items: '1 × Shampoo – 200ml + 1 × Hair Oil – 100ml',
    price: 899,
  },
  {
    name: 'Custom Order',
    items: 'Any quantity of Shampoo + Any quantity of Oil',
  },
];

function ComboCard({ combo }) {
  const message = `Hi! I'd like to order: ${combo.name}`;
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="catalog-card">
      <h3>{combo.name}</h3>
      <p className="catalog-items">{combo.items}</p>
      {typeof combo.price === 'number' && (
        <div className="catalog-price">Rs {combo.price}/-</div>
      )}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="catalog-order-btn"
      >
        Order on WhatsApp
      </a>
    </div>
  );
}

function Catalog() {
  return (
    <section className="catalog" id="catalog">
      <div className="catalog-header">
        <h2>Products & Pricing</h2>
        <p className="catalog-intro">
          Pick a pack below - every batch is made fresh, in small quantities.
        </p>
      </div>

      <div className="catalog-category">
        <h3 className="catalog-category-title">Makhana</h3>
        <div className="catalog-grid">
          {makhanaPricing.map((combo, idx) => (
            <ComboCard combo={combo} key={idx} />
          ))}
        </div>
      </div>

      <div className="catalog-category">
        <h3 className="catalog-category-title">Hair Care</h3>
        <div className="catalog-grid">
          {hairCareCombos.map((combo, idx) => (
            <ComboCard combo={combo} key={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Catalog;